import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalAlertService } from "src/app/services/global-alert.service";
import { GlobalService } from "src/app/services/global.service";
import * as moment from "moment";
import Swal from "sweetalert2";

@Component({
  selector: "app-historico-datos",
  templateUrl: "./historico-datos.component.html",
  styleUrls: ["./historico-datos.component.css"],
})
export class HistoricoDatosComponent implements OnInit {
  constructor(
    public global: GlobalService,
    public ruta: Router,
    public alerta: GlobalAlertService,
    public spinner: NgxSpinnerService
  ) {
    this.global.initData();
    const vari = localStorage.getItem("USERDATALIWA");
    this.USERDATALIWA = vari.split(",");
    this.global.UserName = this.USERDATALIWA[3];
    this.global.Id_Usuario = this.USERDATALIWA[0];
  }

  // ─── Datos generales ───────────────────────────────────────────────────────
  USERDATALIWA: string[];
  datosBeneficiario: any;
  clientClass: any;
  idTicket: string;
  id_Proyecto: any;
  id_Seccional: any;
  id_Beneficiario: any;
  NombreProyecto: string;
  NombreSeccional: string;

  // ─── Campos del formulario ─────────────────────────────────────────────────
  valorCanal: string;
  valorMenu1: string;
  valorSubMenu1: string = "-";
  valorSubMenu2: string = "-";
  valorSubMenu3: string = "-";
  descriptionBenefit: string;
  typePQRS: string = "prueba";
  Evidence: boolean = false;
  banderaCrearTicket: boolean = false;
  creationDate: string = moment().format("YYYY-MM-DDTHH:mm");

  readonly usuariosConFechaManual = ["747", "749", "755", "756", "750", "641"];

  // ─── Canales ───────────────────────────────────────────────────────────────
  readonly canales = [
    { type: "WhatsApp" },
    { type: "Correo" },
    { type: "Linea de Atencion" },
    { type: "Oficina" },
    { type: "Pagina Web" },
  ];

  // ─── Menú principal ────────────────────────────────────────────────────────
  readonly types = [
    { type: "PETICION" },
    { type: "QUEJA" },
    { type: "RECLAMO" },
    { type: "OTROS" },
  ];

  // ─── Submenús nivel 1 ──────────────────────────────────────────────────────
  readonly typesSubMenu1Peticion = [
    { type: "CONSULTA DE INFORMACION" },
    { type: "SOLICITUD DE FACTURA Y/O COMPROBANTE" },
    { type: "CAMBIO DE TITULARIDAD" },
    { type: "SOLICITUD DE TRASLADO" },
    { type: "AUSENCIA DE EQUIPOS" },
    { type: "SOLICITUD DE DESESTIMIENTO" },
  ];

  readonly typesSubMenu1Queja = [
    { type: "ATENCION DEFICIENTE" },
    { type: "INCONFORMIDAD CON FACTURACION" },
  ];

  readonly typesSubMenu1Reclamo = [
    { type: "DAÑO" },
  ];

  readonly typesSubMenu1Otros = [
    { type: "GESTION DE CARTERA" },
    { type: "LLAMADA DE INFORMACION" },
    { type: "GESTION SOCIAL" },
    { type: "RESULTADO OPERATIVO" },
  ];

  // ─── Submenús nivel 2 ──────────────────────────────────────────────────────

  // Peticion
  readonly typesSubMenu2ConsultaInformacion = [
    { type: "INFORMACION DEL CONTRATO" },
    { type: "ACUERDOS INICIALES" },
  ];

  readonly typesSubMenu2SolicitudFactura = [
    { type: "COPIA DE FACTURA" },
    { type: "COPIA DE COMPROBANTE DE PAGO" },
    { type: "SOLICITUD ESTADO DE CARTERA" },
  ];

  // Queja
  readonly typesSubMenu2AtencionDeficiente = [
    { type: "QUEJAS ADMINISTRATIVAS" },
    { type: "INTERRUPCIONES EN LA PRESTACION DEL SERVICIO" },
    { type: "NO ATENCION DE CONDICIONES DE SEGURIDAD O RIESGO" },
    { type: "TERMINACION DEL CONTRATO" },
    { type: "SUSPENSION O CORTE DEL SERVICIO SIN PREVIO AVISO O SIN CAUSA APARENTE" },
    { type: "AFECTACION AMBIENTAL" },
    { type: "ESTADO DE LA INFRAESTRUCTURA" },
    { type: "FALLAS EN LA CONEXION DEL SERVICIO" },
    { type: "NO CONEXION DEL SERVICIO" },
  ];

  readonly typesSubMenu2InconformidadFacturacion = [
    { type: "COBROS INOPORTUNOS" },
    { type: "COBRO POR SERVICIOS NO PRESTADOS" },
    { type: "DATOS GENERALES INCORRECTOS" },
    { type: "COBRO MULTIPLE Y/O ACUMULADO" },
    { type: "ENTREGA INOPORTUNA O NO ENTREGA DE LA FACTURA" },
    { type: "COBRO POR CONEXION, RECONEXION, REINSTALACION" },
    { type: "COBRO DE CARGOS RELACIONADOS A CARTERA Y/O ACUERDOS DE PAGO" },
    { type: "SUBSIDIOS Y CONTRIBUCIONES" },
    { type: "DESCUENTO POR PREDIO DESOCUPADO" },
    { type: "INCUMPLIMIENTO O NEGACION DEL ACUERDO DE SUSPENSION DEL SERVICIO" },
    { type: "ESTRATO INCORRECTO" },
    { type: "CLASE DE USO INCORRECTO (COMERCIAL, INDUSTRIAL, OFICIAL, OTROS)" },
    { type: "TARIFA INCORRECTA" },
    { type: "COBROS POR PROMEDIO" },
    { type: "SUSCRIPTOR QUE EFECTUA EL PAGO PERO ESTE NO ES APLICADO POR LA EMPRESA EN LA FACTURACION" },
    { type: "INCONFORMIDAD POR LA NORMALIZACION DEL SERVICIO" },
    { type: "NEGACION DE LA SOLICITUD DE SUSPENSION" },
  ];

  // Reclamo — defaultBloquea: true → "BLOQUEA FACTURACION" por defecto, false → "NO BLOQUEA FACTURACION"
  readonly typesSubMenu2Dano = [
    { type: "UN EQUIPO NO PRENDE",          defaultBloquea: true  },
    { type: "EL SISTEMA NO PRENDE",         defaultBloquea: true  },
    { type: "EL SISTEMA NO PRENDE DE NOCHE",defaultBloquea: true  },
    { type: "SISTEMA PITANDO / ALARMA",     defaultBloquea: true  },
    { type: "AUSENCIA DE EQUIPOS",          defaultBloquea: false },
  ];

  // Otros
  readonly typesSubMenu2GestionCartera = [
    { type: "ACUERDO DE PAGO" },
    { type: "PAGO MENSUAL" },
    { type: "SIN PROMESA" },
    { type: "EQUIVOCADO" },
    { type: "BUZON DE MENSAJES" },
    { type: "MENSAJE DE TEXTO" },
    { type: "NO CONTESTA" },
    { type: "MENSAJE CON TERCERO" },
  ];

  readonly typesSubMenu2LlamadaInformacion = [
    { type: "REPORTE GENERAL" },
    { type: "NO CONTESTA" },
    { type: "EQUIVOCADO" },
    { type: "BUZON DE MENSAJES" },
    { type: "MENSAJE CON TERCERO" },
  ];

  readonly typesSubMenu2GestionSocial = [
    { type: "HURTO PARCIAL",          defaultBloquea: true  },
    { type: "HURTO COMPLETO",         defaultBloquea: true  },
    { type: "TRASLADO NO AUTORIZADO", defaultBloquea: false },
    { type: "SOLUCION ABANDONADA",    defaultBloquea: false },
    { type: "RESTRICCIONES DE ACCESO",defaultBloquea: false },
    { type: "SISFV FUNCIONAL",        defaultBloquea: false },
    { type: "SISFV NO FUNCIONAL",        defaultBloquea: false },
  ];

  // Resultado Operativo — defaultBloquea: true → "BLOQUEA FACTURACION", false → "NO BLOQUEA FACTURACION"
  readonly typesSubMenu2ResultadoOperativo = [
    { type: "REPOSICION",               defaultBloquea: true  },
    { type: "SISFV NO ENCONTRADA",      defaultBloquea: false },
    { type: "RESTRICCIONES ACCESO",     defaultBloquea: false },
    { type: "AUSENTE",                  defaultBloquea: false },
    { type: "AUSENCIA DE EQUIPOS",      defaultBloquea: false },
    { type: "SUSPENSION DEL SERVICIO",  defaultBloquea: false },
    { type: "RECONEXION DEL SERVICIO",  defaultBloquea: false },
    { type: "EQUIPOS MODIFICADOS(HOMOLOGACION)",  defaultBloquea: false },
  ];

  // ─── Submenús nivel 3 ──────────────────────────────────────────────────────
  // Compartido: Reclamo > Daño > * y Otros > Gestion Social > * y Otros > Resultado Operativo > *
  readonly typesSubMenu3Facturacion = [
    { type: "BLOQUEA FACTURACION" },
    { type: "NO BLOQUEA FACTURACION" },
    { type: "DESCUENTO COMERCIAL" },
  ];

  // ─── Visibilidad submenús nivel 1 ──────────────────────────────────────────
  opcionPeticion: boolean = false;
  opcionQueja: boolean = false;
  opcionReclamo: boolean = false;
  opcionOtros: boolean = false;

  // ─── Visibilidad submenús nivel 2 ──────────────────────────────────────────
  opcionSub2ConsultaInfo: boolean = false;
  opcionSub2SolicitudFactura: boolean = false;
  opcionSub2AtencionDeficiente: boolean = false;
  opcionSub2InconformidadFacturacion: boolean = false;
  opcionSub2Dano: boolean = false;
  opcionSub2GestionCartera: boolean = false;
  opcionSub2LlamadaInformacion: boolean = false;
  opcionSub2GestionSocial: boolean = false;
  opcionSub2ResultadoOperativo: boolean = false;

  // ─── Visibilidad submenús nivel 3 ──────────────────────────────────────────
  opcionSub3Facturacion: boolean = false;
  mensajeAdvertenciaSubMenu3: string = "";

  // ─── Lifecycle ─────────────────────────────────────────────────────────────
  ngOnInit(): void {
    this.clientClass = this.global.CLIENTDATALIWA[8];
    this.datosBeneficiario =
      this.global.informacionBeneficiario ??
      JSON.parse(window.localStorage.getItem("informacion_beneficiario") || "null") ??
      JSON.parse(window.localStorage.getItem("informacion beneficiario") || "null");

    // Si se recargó la página y no hay datos del beneficiario, volver a crear-ticket
    if (!this.datosBeneficiario || !this.datosBeneficiario[0]) {
      this.ruta.navigateByUrl("/crear-ticket");
      return;
    }

    if (this.global.banderaModificaionTicket) {
      this.spinner.show();
      this.spinner.hide();
    }

    const pdata9 = {
      option: "insertar2",
      texto: `SELECT Nombre,(SELECT Nombre FROM db_liwa.Seccionales WHERE id_Seccional = ${this.datosBeneficiario[0][4]}) FROM db_liwa.tipoProyecto WHERE id_tipoProyecto = ${this.datosBeneficiario[0][3]};`,
    };
    this.global.consultar(pdata9, async (err9, response9) => {
      this.NombreProyecto = await response9[0][0];
      this.NombreSeccional = await response9[0][1];
    });
  }

  // ─── Helpers ───────────────────────────────────────────────────────────────
  get permiteFechaManual(): boolean {
    return this.usuariosConFechaManual.includes(this.global.Id_Usuario);
  }

  get permiteResultadoOperativo(): boolean {
    return this.usuariosConFechaManual.includes(this.global.Id_Usuario);
  }

  get typesSubMenu1OtrosVisible() {
    return this.typesSubMenu1Otros.filter(
      item => item.type !== "RESULTADO OPERATIVO" || this.permiteResultadoOperativo
    );
  }

  private resetSubMenus1(): void {
    this.opcionPeticion = false;
    this.opcionQueja = false;
    this.opcionReclamo = false;
    this.opcionOtros = false;
  }

  private resetSubMenus2(): void {
    this.opcionSub2ConsultaInfo = false;
    this.opcionSub2SolicitudFactura = false;
    this.opcionSub2AtencionDeficiente = false;
    this.opcionSub2InconformidadFacturacion = false;
    this.opcionSub2Dano = false;
    this.opcionSub2GestionCartera = false;
    this.opcionSub2LlamadaInformacion = false;
    this.opcionSub2GestionSocial = false;
    this.opcionSub2ResultadoOperativo = false;
  }

  private resetSubMenus3(): void {
    this.opcionSub3Facturacion = false;
    this.mensajeAdvertenciaSubMenu3 = "";
  }

  // ─── Manejadores de cambio ─────────────────────────────────────────────────
  handleChangeSubMenu1(): void {
    this.resetSubMenus1();
    this.resetSubMenus2();
    this.resetSubMenus3();
    this.valorSubMenu1 = "-";
    this.valorSubMenu2 = "-";
    this.valorSubMenu3 = "-";
    this.banderaCrearTicket = false;

    switch (this.valorMenu1) {
      case "PETICION": this.opcionPeticion = true; break;
      case "QUEJA":    this.opcionQueja = true;    break;
      case "RECLAMO":  this.opcionReclamo = true;  break;
      case "OTROS":    this.opcionOtros = true;    break;
    }
  }

  handleChangeSubMenu2(): void {
    this.resetSubMenus2();
    this.resetSubMenus3();
    this.valorSubMenu2 = "-";
    this.valorSubMenu3 = "-";
    this.banderaCrearTicket = false;

    switch (this.valorSubMenu1) {
      // ── Peticion ──
      case "CONSULTA DE INFORMACION":
        this.opcionSub2ConsultaInfo = true;
        break;
      case "SOLICITUD DE FACTURA Y/O COMPROBANTE":
        this.opcionSub2SolicitudFactura = true;
        break;
      case "CAMBIO DE TITULARIDAD":
      case "SOLICITUD DE TRASLADO":
      case "AUSENCIA DE EQUIPOS":
      case "SOLICITUD DE DESESTIMIENTO":
        this.valorSubMenu3 = "NO BLOQUEA FACTURACION";
        this.banderaCrearTicket = true; // sin submenú2, habilita directo
        break;

      // ── Queja ──
      case "ATENCION DEFICIENTE":
        this.opcionSub2AtencionDeficiente = true;
        break;
      case "INCONFORMIDAD CON FACTURACION":
        this.opcionSub2InconformidadFacturacion = true;
        break;

      // ── Reclamo ──
      case "DAÑO":
        this.opcionSub2Dano = true;
        break;

      // ── Otros ──
      case "GESTION DE CARTERA":
        this.opcionSub2GestionCartera = true;
        break;
      case "LLAMADA DE INFORMACION":
        this.opcionSub2LlamadaInformacion = true;
        break;
      case "GESTION SOCIAL":
        this.opcionSub2GestionSocial = true;
        break;
      case "RESULTADO OPERATIVO":
        this.opcionSub2ResultadoOperativo = true;
        break;
    }
  }

  handleChangeSubMenu3(): void {
    this.resetSubMenus3();
    this.valorSubMenu3 = "-";
    this.banderaCrearTicket = false;

    const esDano        = this.valorMenu1 === "RECLAMO" && this.valorSubMenu1 === "DAÑO";
    const esTraslado    = this.valorMenu1 === "OTROS"   && this.valorSubMenu1 === "GESTION SOCIAL";
    const esResultadoOp = this.valorMenu1 === "OTROS"   && this.valorSubMenu1 === "RESULTADO OPERATIVO";

    if ((esDano || esTraslado || esResultadoOp) && this.valorSubMenu2 && this.valorSubMenu2 !== "-") {
      this.opcionSub3Facturacion = true;

      let defaultBloquea: boolean | undefined;

      if (esDano) {
        const op = this.typesSubMenu2Dano.find(d => d.type === this.valorSubMenu2);
        defaultBloquea = op?.defaultBloquea;
      } else if (esResultadoOp) {
        const op = this.typesSubMenu2ResultadoOperativo.find(d => d.type === this.valorSubMenu2);
        defaultBloquea = op?.defaultBloquea;
      } else if (esTraslado) {
        const op = this.typesSubMenu2GestionSocial.find(d => d.type === this.valorSubMenu2);
        defaultBloquea = op?.defaultBloquea;
      }

      if (defaultBloquea !== undefined) {
        this.valorSubMenu3 = defaultBloquea ? "BLOQUEA FACTURACION" : "NO BLOQUEA FACTURACION";
        const defaultTexto = defaultBloquea ? "BLOQUEA FACTURACION" : "NO BLOQUEA FACTURACION";
        this.mensajeAdvertenciaSubMenu3 = `"${this.valorSubMenu2}" por defecto ${defaultTexto}.`;
      }

      this.banderaCrearTicket = true;
    } else if (this.valorSubMenu2 && this.valorSubMenu2 !== "-") {
      // Sin SubMenu3: asignar automáticamente según tipificación (no bloquean facturación)
      this.valorSubMenu3 = "NO BLOQUEA FACTURACION";
      this.banderaCrearTicket = true;
    }
  }

  handleChangeDescriction(): void {
    if (this.valorSubMenu3 && this.valorSubMenu3 !== "-") {
      this.banderaCrearTicket = true;
    }
    this.mensajeAdvertenciaSubMenu3 = this.calcularAdvertenciaSubMenu3();
  }

  private calcularAdvertenciaSubMenu3(): string {
    if (!this.valorSubMenu2 || this.valorSubMenu2 === "-") return "";
    if (!this.valorSubMenu3 || this.valorSubMenu3 === "-") return "";

    let item: { type: string; defaultBloquea?: boolean } | undefined;

    const esDano        = this.valorMenu1 === "RECLAMO" && this.valorSubMenu1 === "DAÑO";
    const esTraslado    = this.valorMenu1 === "OTROS"   && this.valorSubMenu1 === "GESTION SOCIAL";
    const esResultadoOp = this.valorMenu1 === "OTROS"   && this.valorSubMenu1 === "RESULTADO OPERATIVO";

    if (esDano)         item = this.typesSubMenu2Dano.find(d => d.type === this.valorSubMenu2);
    else if (esTraslado) item = this.typesSubMenu2GestionSocial.find(d => d.type === this.valorSubMenu2);
    else if (esResultadoOp) item = this.typesSubMenu2ResultadoOperativo.find(d => d.type === this.valorSubMenu2);

    if (!item || item.defaultBloquea === undefined) return "";

    const defaultTexto = item.defaultBloquea ? "BLOQUEA FACTURACION" : "NO BLOQUEA FACTURACION";
    if (this.valorSubMenu3 !== defaultTexto) {
      return `Recuerda que "${this.valorSubMenu2}" por defecto ${defaultTexto}.`;
    }
    return `"${this.valorSubMenu2}" por defecto ${defaultTexto}.`;
  }

  // ─── Navegación ────────────────────────────────────────────────────────────
  atras(): void {
    if (this.global.banderaModificaionTicket) {
      this.global.banderaModificaionTicket = false;
      this.ruta.navigateByUrl("/user-ticket");
    } else {
      window.localStorage.setItem("informacion beneficiario", JSON.stringify([]));
      this.ruta.navigateByUrl("/crear-ticket");
    }
  }

  // ─── Normalizar tipificación: MAYÚSCULAS · sin tildes (excepto Ñ) · sin dobles espacios ─
  private normalizarTipificacion(s: string): string {
    if (!s) return s;
    // Preservar ñ/Ñ antes de eliminar diacríticos
    return s
      .replace(/ñ/g, '__NIO__').replace(/Ñ/g, '__NIO__')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/__NIO__/g, 'Ñ')
      .toUpperCase()
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  // ─── Navegar a ver-ticket dejando el contexto listo ────────────────────────
  private _irAVerTicket(): void {
    this.global.Id_Ticket = this.idTicket;
    localStorage.setItem("Id_Ticket", this.idTicket);
    this.global.informacion = this.datosBeneficiario;
    localStorage.setItem("informacion", JSON.stringify(this.datosBeneficiario));
    this.ruta.navigateByUrl("/ver-ticket");
  }

  // ─── Crear ticket ──────────────────────────────────────────────────────────
  crear(): void {
    if (this.Evidence) return;

    this.spinner.show();
    const exMoment = `${this.global.Id_Usuario}_${moment.now()}`;
    this.idTicket = this.global.Id_Ticket || exMoment;

    const creationDateFinal = this.permiteFechaManual
      ? moment(this.creationDate).format("YYYY-MM-DD HH:mm:ss")
      : moment().format("YYYY-MM-DD HH:mm:ss");

    if (!this.valorCanal) {
      this.alerta.descErr("Debe seleccionar un canal de atención");
      this.spinner.hide();
      return;
    }

    if (!this.typePQRS) {
      this.alerta.descErr("Revise por favor que no hay campos vacíos");
      this.spinner.hide();
      return;
    }

    setTimeout(() => {
      const idStatuses =
        this.valorSubMenu2 === "Agendamiento visita" ? 8
        : this.valorMenu1 === "llamada outbound" ? 11
        : 1;

      this.id_Proyecto = this.global.banderaModificaionTicket
        ? this.id_Proyecto : this.datosBeneficiario[0][3];
      this.id_Seccional = this.global.banderaModificaionTicket
        ? this.id_Seccional : this.datosBeneficiario[0][4];
      this.id_Beneficiario = this.global.banderaModificaionTicket
        ? this.id_Beneficiario : this.datosBeneficiario[0][1];

      const nMenu  = this.normalizarTipificacion(this.valorMenu1);
      const nSub1  = this.normalizarTipificacion(this.valorSubMenu1);
      const nSub2  = this.normalizarTipificacion(this.valorSubMenu2 || '-');
      const nSub3Raw = (this.valorSubMenu3 && this.valorSubMenu3 !== '-') ? this.valorSubMenu3 : 'NO BLOQUEA FACTURACION';
      const nSub3  = this.normalizarTipificacion(nSub3Raw);

      const query =
        `REPLACE INTO db_liwa.Tickets_New (Id_Tickets,Id_Usuario,Id_Proyecto,Id_Seccional,Id_Statuses,Id_Beneficiario,Menu,SubMenu1,SubMenu2,SubMenu3,Description,Creation_Date,Encargado,IsDelete,IsActive,IsArchived,Codigo,canal)` +
        ` VALUES ('${this.idTicket}','${this.global.Id_Usuario}','${this.id_Proyecto}','${this.id_Seccional}','${idStatuses}','${this.id_Beneficiario}',` +
        `'${nMenu}','${nSub1}','${nSub2}','${nSub3}','${this.descriptionBenefit}',` +
        `'${creationDateFinal}','-','0','1','0','${idStatuses}','${this.valorCanal}');`;

      const pdata1 = { option: "insertar3", texto: query };
      this.global.consultar(pdata1, (err, response) => {
        if (response !== true) {
          this.alerta.descErr("Revise por favor que no hay campos vacíos");
          this.spinner.hide();
          return;
        }

        const idStatusesUpdate = this.valorMenu1 === "llamada outbound" ? 1 : idStatuses;
        const query2 =
          `REPLACE INTO db_liwa.Update_Tickets (Id_Ticket,Description,Date,Id_Statuses,IsDelete,IsActive)` +
          ` VALUES ('${this.idTicket}','PQRS Creada','${creationDateFinal}','${idStatusesUpdate}','0','1');`;

        this.global.consultar({ option: "insertar3", texto: query2 }, (err2, response2) => {
          if (err2 != null || response2 !== true) {
            this.alerta.descErr("Revise por favor que no hay campos vacíos");
            this.spinner.hide();
            return;
          }

          // Crear escalamiento automático si la tipificación tiene responsable asignado
          this.crearEscalamientoSiCorresponde(this.idTicket, '');

          // Solo Reclamo (Daño) sugiere agendar visita técnica
          if (this.valorMenu1 === "Reclamo" && this.global.idRole !== 15) {
            this.spinner.hide();
            Swal.fire({
              title: '<strong>¿Desea Agendar una visita?</strong>',
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              focusConfirm: false,
              confirmButtonColor: "#093579",
              cancelButtonText: "No, Gracias!!",
              confirmButtonText: "Si, estoy seguro",
            }).then((result) => {
              if (result.isConfirmed) {
                this.global.withoutTicket = false;
                this.global.selectedForVisit = [
                  this.valorMenu1, this.NombreProyecto, this.NombreSeccional,
                  this.datosBeneficiario[0][4], this.datosBeneficiario[0][8], this.descriptionBenefit,
                  "", "", "", "", "", "", "",
                ];
              }
              this.alerta.descValid("Nueva PQRS creada con éxito");
              this._irAVerTicket();
            });
          } else {
            this.spinner.hide();
            this.alerta.descValid("Nueva PQRS creada con éxito");
            this.global.banderaModificaionTicket = false;
            this._irAVerTicket();
          }
        });
      });
    }, 400);
  }

  // ─── Lógica de escalamiento ────────────────────────────────────────────────
  private getTipificacionEscalamiento(): string {
    // Tipificaciones que se mapean al nivel de subMenu1 (no al subMenu2)
    if (this.valorSubMenu1 === 'GESTION DE CARTERA') return 'GESTION DE CARTERA';
    if (this.valorSubMenu1 === 'LLAMADA DE INFORMACION') return 'LLAMADA DE INFORMACION';
    if (this.valorSubMenu1 === 'GESTION SOCIAL') return 'GESTION SOCIAL';
    // Reclamo > Daño siempre escala a "DAÑO" independientemente del subMenu2
    if (this.valorMenu1 === 'RECLAMO' && this.valorSubMenu1 === 'DAÑO') return 'DAÑO';
    // Para Resultado Operativo, el subMenu2 es la tipificación específica
    if (this.valorSubMenu1 === 'RESULTADO OPERATIVO' && this.valorSubMenu2 && this.valorSubMenu2 !== '-') return this.valorSubMenu2;
    // Casos con subMenu2 seleccionado (e.g. Consulta de Información > Información del contrato)
    if (this.valorSubMenu2 && this.valorSubMenu2 !== '-') return this.valorSubMenu2;
    // Casos sin subMenu2 (e.g. Cambio de Titularidad, Ausencia de Equipos, etc.)
    if (this.valorSubMenu1 && this.valorSubMenu1 !== '-') return this.valorSubMenu1;
    return this.valorMenu1;
  }

  private crearEscalamientoSiCorresponde(idTicket: string, descripcion: string): void {
    const tipificacion = this.getTipificacionEscalamiento();
    const pdataEscalamiento = {
      option: 'crear-escalamiento',
      idticket: idTicket,
      tipificacion: tipificacion,
      // La descripción del escalamiento NO debe heredarse de la descripción del ticket.
      // Solo se debe diligenciar cuando el escalamiento sea gestionado.
      descripcionEscalamiento: (descripcion || '').trim() || null,
      idUsuarioEscalamiento: this.global.Id_Usuario,
    };
    this.global.consultar(pdataEscalamiento, (err, response) => {
      if (err) {
        console.error('Error al crear escalamiento:', err);
      }
      // No se muestra alerta: el escalamiento es secundario al ticket
    });
  }

  // ─── Crear comentario ──────────────────────────────────────────────────────
  crearUnComentario(): void {
    const pdataComentario = {
      option: "insertar3",
      texto: `INSERT INTO db_liwa.Comentarios_Tickets (Comentario, Id_Ticket, Id_Usuario)
         VALUES('${this.descriptionBenefit}', '${this.global.Id_Ticket}', '${this.global.Id_Usuario}');`,
    };
    this.global.consultar(pdataComentario, (err, response) => {
      if (response !== true) return;

      const query2 =
        `REPLACE INTO db_liwa.Update_Tickets (Id_Ticket,Description,Date,Id_Statuses,IsDelete,IsActive)` +
        ` VALUES ('${this.global.Id_Ticket}','Comentario creado por llamada del cliente','${moment().format("YYYY-MM-DD HH:mm:ss")}','13','0','1');`;

      this.global.consultar({ option: "insertar3", texto: query2 }, () => {
        this.spinner.hide();
        this.alerta.descValid("Nuevo Comentario creado con éxito");
        this.global.banderaModificaionTicket = false;
        this.global.Id_Ticket = "-";
        this.ruta.navigateByUrl("/user-ticket");
      });
    });
  }

}
